import { render } from "./ProfessionalSelectionDrawer.vue?vue&type=template&id=c70b9e56"
import script from "./ProfessionalSelectionDrawer.vue?vue&type=script&lang=js"
export * from "./ProfessionalSelectionDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__